import { z } from 'zod';

/** Matches backend Note.content / NoteContentUpdate max_length=500. */
export const noteContentSchema = z.object({
  content: z.string().max(500, 'Note must be less than 500 characters'),
});

/** Matches backend NoteContentUpdate max_length=500 (stored notes / templates). */
export const noteContentUpdateSchema = z.object({
  content: z.string().max(500, 'Note must be less than 500 characters'),
});

export type NoteContentFormData = z.infer<typeof noteContentSchema>;
export type NoteContentUpdateFormData = z.infer<typeof noteContentUpdateSchema>;
